module.exports = __webpack_public_path__ + "img/appcardiosalus.5fd261b6.jpg";